import InView from 'inview';
import { CountUp } from 'countup.js/dist/countUp.umd';

export class Stat {
	isCounting = false;

	constructor(el) {
		if (el) {
			this.el = el;
			this.number = this.el.dataset.number;

			let decimalPlaces = 0;
			const decimalIndex = this.number.indexOf('.');
			if (decimalIndex > 0) {
				decimalPlaces = this.number.length - decimalIndex - 1;
			}

			this.countUpOptions = { decimalPlaces };
			this.countUp = new CountUp(this.el, this.number, this.countUpOptions);
			this.inView = InView(this.el, this.handleInView);
		}
	}

	handleInView = (isInView) => {
		if (isInView) {
			if (!this.isCounting) {
				this.isCounting = true;
				this.countUp.start();
			}
		}
	}
}

export function initStats() {
	const statEls = [...document.querySelectorAll('.js-counter[data-number]')];
	if (statEls.length) {
		embark.components.stats = statEls.map((el) => {
			if (!el.closest('.wp-block-embark-tabpanel') || document.body.classList.contains('wp-admin')) {
				return new Stat(el);
			}

			return false;
		});
	}
}

document.addEventListener('DOMContentLoaded', initStats);
